<template>
	<div class="picture_and_video_box">
		<div v-if="fileList && fileList.SlideTotal > 0" class="media-carousel" @mouseenter="stopAutoplay()"  @mouseleave="startAutoplay()"  :ref="videoSlide_post_id">
		
			<!-- :ref="'swiper' + fileList ? fileList.post_id : 1" -->
			<swiper 
				:id="swiper_post_id"
				:ref="swiper_post_id"
				class="swiper swiperBox" 
				:options="swiperOption" 
				@mouseenter="stopAutoplay" 
				@mouseleave="startAutoplay"
				@slideChangeTransitionEnd="change"
			>	
				<!-- 总数和当前数 -->
				<div class="quantityBox" v-if="fileList && fileList.SlideTotal > 1">
					<div class="quantity">{{ fileList.currentSlideIndex ? fileList.currentSlideIndex : 1 }}</div>
					<div class="quantity">/</div>
					<div class="quantity">{{ fileList.SlideTotal }}</div>
				</div>
				<!-- 图片轮播 -->
				<swiper-slide
					v-if="(fileList.post_type == 1 || fileList.type == 1 ) && fileList.pics && fileList.pics.length > 0"
					v-for="(img_item, img_index) in fileList.pics"
					:key="'img-' + img_index"
					:class="img_item.video ? 'slideLiveBox' : ''"
					:style="img_item.background ? img_item.background : ''"
				>
					<div class="slide_item" @click="OpenPreviewSwiper(fileList, img_item, 'swiperSlideImg')">
						<div v-if="img_item.video && checkBrowser()" class="LiveBtn" :class="!img_item.LivePlayState ? 'pointer' : 'no-drop noBtn'" @click.stop="LivePlay(img_item)">{{ $t('SwiperArr.Live') }}</div>
						<img v-if="!img_item.LivePlayState" :src="img_item.url"  class="media-image" :alt="'The TOZO community post contains a picture of ' + fileList.content" @click="OpenPreviewSwiper(fileList, img_item, 'swiperSlideImg')"/>
						
						<video v-else :src="img_item.video" :ref="liveVideo_post_id" autoplay muted playsinline class="Live-video" @ended="stopLivePlay(img_item)" >
							<source :src="img_item.video" type="video/mp4;">
							<!-- <source src="https://s3-us-tozo-test-wr.tozostore.com/Admin/app30/video/202501070712262626_1736233946qBnvkNdkM6VRX61g.mp4" type="video/mp4"> -->
						</video>
					</div>
				</swiper-slide>

				<!-- 视频轮播 -->
				<swiper-slide
					v-if="(fileList.post_type == 2 || fileList.type == 2 ) && fileList.videos && fileList.videos.length > 0"
					v-for="(video_item, video_index) in fileList.videos"
					:key="'video-' + video_index"
				>
					<div class="slide_item">
						<video :src="video_item" :ref="videoPlayer_post_id" controls class="media-video" :autoplay="isDetailPage()" muted :poster="fileList.video_cover">
							<source :src="video_item" type="video/mp4">
						</video>
					</div>
					<!-- <div class="slide_item" @click="OpenPreviewSwiper(fileList, video_item, 'swiperSlidevideo')">
						<video :src="video_item" controls class="media-video" :poster="fileList.video_cover" @click="OpenPreviewSwiper(fileList, video_item, 'swiperSlidevideo')">
							<source :src="video_item" type="video/mp4">
						</video>
					</div> -->
				</swiper-slide>
				<!-- Pagination -->
				<!-- <div class="swiper-pagination"></div> -->
				<div v-show="fileList && fileList.SlideTotal > 1" class="swiper-pagination" @click.stop></div>
			</swiper>
		</div>
		
		<handlePreviewSwiper v-if="handlePreviewShow" :fileList="PreviewSwiper" :currentUrl="currentUrl" :itemtype="swiperSlide" @closurePreview="handlePreviewShow = false"></handlePreviewSwiper>
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import handlePreviewSwiper from './handlePreviewSwiper.vue';
// import 'swiper/css/swiper.css'

export default {
  name: 'MediaContent',
  components: { Swiper, SwiperSlide },
  props: {
    fileList: {
      type: Object,
        default: () => ({
            SlideTotal: 0,
            pics: [
					{LivePlayState: false}
				],
            videos: [],
            currentSlideIndex: 1,
				// videosAutoplay: false,
        })
    },
    swiperList: {
      type: Array,
      default() {
        return [{}];
      },
    },
  },
	computed: {
		swiper() {
			return this.$refs[`swiper${this.fileList.post_id}`].$swiper
		},
		liveVideo() {
			return this.$refs[`liveVideo${this.fileList.post_id}`]
		},
		videoPlayer() {
			return this.$refs[`videoPlayer${this.fileList.post_id}`]
		},
		videoSlide() {
			return this.$refs[`videoSlide${this.fileList.post_id}`]
		}
	},
	
  data() {
		return {
        swiper_post_id: `swiper${this.fileList.post_id}`,
        liveVideo_post_id: `liveVideo${this.fileList.post_id}`,
		  videoPlayer_post_id: `videoPlayer${this.fileList.post_id}`,
		  videoSlide_post_id: `videoSlide${this.fileList.post_id}`,
        swiperOption: {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: this.fileList && this.fileList.SlideTotal > 1,
            touchMoveStopPropagation: true,
            autoplay: this.fileList && this.fileList.SlideTotal > 1? {
               delay: 5000,
               disableOnInteraction: false
            } : false,
            effect: 'fade',
            preventClicks: true,
            fadeEffect: { crossFade: true },
            pagination: {
               el: '.swiper-pagination',
               type: 'bullets',
               clickable: true
            },
            navigation: {
               nextEl: '.swiper-button-next',
               prevEl: '.swiper-button-prev'
            },
            rtl: true,
				on: {
				  click:function(clickedIndex){},
				},
				realIndex: 0,
				indexOfPlayingVideo: NaN,
				pauseVideoCb: function() {}
			},
			PreviewSwiper:[],
			currentUrl: "",
			handlePreviewShow: false,
			swiperSlide: "",
			observer: null
		};
  },
  
  watch: {
  	"$route": {
  		handler: function (val, oldval) {
			this.$nextTick(() => {
				this.set_bg_color()
			});
  		}
  	},
  	"fileList": {
  		handler: function (val, oldval) {
			this.$nextTick(() => {
				this.set_bg_color()
			});
  		}
  	},
	
  },
  
	// 路由进入可操作数据
	activated() {
		this.set_bg_color()
		this.$nextTick(() => {
			this.change()
			this.play_video()
		});
	},

	created() {
		
	},
	
	beforeDestroy() {
	   if (this.observer) {
	      this.observer.disconnect();
	   }
	},
	
	mounted() {
		console.log(this.fileList)
		this.set_bg_color()
		this.isDetailPage()
		// 然后获取Swiper实例相关操作
		this.$nextTick(() => {
			this.change()
			this.play_video()
		});
	},

	methods: {
		isDetailPage(){
			let PostDetails = (this.fileList.post_type == 2 || this.fileList.type == 2 ) && this.$route.name.includes('post-details') 
			// if(PostDetails){
			// 	this.$set(this.fileList, 'videosAutoplay', true);
			// }else{
			// 	this.$set(this.fileList, 'videosAutoplay', false);
			// }
			return PostDetails
		},
		
		play_video() {
			console.log(this.isDetailPage())
		    if (this.isDetailPage()) {
		      // 详情页，加载后自动播放
		      this.$nextTick(() => {
		        // this.videoPlayer.play().catch(err => {
		        //   console.log("自动播放失败：", err);
		        // });
		      });
		    } else {
		      // 列表页，监听可视区域
		      this.setupObserver();
		    }
		},
		
		setupObserver2() {
		  if (this.fileList.post_type === 2 || this.fileList.type === 2) {
		    this.$nextTick(() => {
		      let videoSlide = this.$refs[`videoSlide${this.fileList.post_id}`];
		      let videoPlayer = this.$refs[`videoPlayer${this.fileList.post_id}`];
		
		      // console.log("videoSlide:", videoSlide);
		      // console.log("videoPlayer:", videoPlayer);
		
		      // 确保 videoSlide 是 HTML 元素
		      videoSlide = Array.isArray(videoSlide) ? videoSlide[0] : videoSlide;
		      if (!videoSlide || !(videoSlide instanceof Element)) {
		        console.error("videoSlide 为空或不是 HTML 元素，无法监听可视区域");
		        return;
		      }
		
		      // 确保 videoPlayer 是 HTMLVideoElement
		      videoPlayer = Array.isArray(videoPlayer) ? videoPlayer[0] : videoPlayer;
		      if (!videoPlayer || !(videoPlayer instanceof HTMLVideoElement)) {
		        console.error("videoPlayer 为空或不是 HTMLVideoElement");
		        return;
		      }
		
		      // 使用 IntersectionObserver 监听元素的可视区域
		      this.observer = new IntersectionObserver((entries) => {
		        entries.forEach(entry => {
		          let rect = entry.boundingClientRect;
		          let viewportHeight = window.innerHeight; // 视口高度
		          
		          // 获取元素中心点的位置，相对于视口
		          let elementCenter = rect.height;
		
		          // 计算屏幕垂直中间区域（上下 20% 可调整）
		          let middleStart = viewportHeight * 0.4;
		          let middleEnd = viewportHeight * 0.6;
		
		          console.log("元素中心点:", elementCenter);
		          console.log("屏幕中间范围:", middleStart, middleEnd);
		
		          if (elementCenter >= middleStart && elementCenter <= middleEnd) {
		            videoPlayer.play().catch(err => console.log("自动播放失败:", err));
		          } else {
		            videoPlayer.pause();
		          }
		        });
		      }, { threshold: 0 }); // 只要元素进入视口就计算
		
		      this.observer.observe(videoSlide);
		    });
		  }
		},
		
		setupObserver() {
		  if (this.fileList.post_type === 2 || this.fileList.type === 2) {
		    let videoSlide = this.$refs[`videoSlide${this.fileList.post_id}`];
		    let videoPlayer = this.$refs[`videoPlayer${this.fileList.post_id}`];
		
		    // 确保 videoSlide 是 HTML 元素
		    videoSlide = Array.isArray(videoSlide) ? videoSlide[0] : videoSlide;
		    if (!videoSlide || !(videoSlide instanceof Element)) {
		      console.error("videoSlide 为空或不是 HTML 元素，无法监听可视区域");
		      return;
		    }
		
		    // 确保 videoPlayer 是 HTMLVideoElement
		    videoPlayer = Array.isArray(videoPlayer) ? videoPlayer[0] : videoPlayer;
		    if (!videoPlayer || !(videoPlayer instanceof HTMLVideoElement)) {
		      console.error("videoPlayer 为空或不是 HTMLVideoElement");
		      return;
		    }
		
			 let that =  this
		    this.observer = new IntersectionObserver((entries) => {
		      entries.forEach(entry => {
		        if (entry.isIntersecting) {
						videoPlayer.play().catch(err => console.log("自动播放失败:", err));
		        } else {
		          videoPlayer.pause();
		        }
		      });
		    }, { threshold: 0.7 }); //threshold取值在0.0-1.0，0.5指占50%
		
		    this.observer.observe(videoSlide);
		  }
		},
		
		OpenPreviewSwiper(fileList, item, swiperSlide){
			let currentRouteName = this.$route.name;
			if(currentRouteName.includes('post-details')){ 
				this.PreviewSwiper = fileList
				this.currentUrl = item
				this.swiperSlide = swiperSlide
				this.handlePreviewShow = true
			}
		},
		
		checkBrowser() {
		   const userAgent = navigator.userAgent.toLowerCase();
		   const isSafari = /safari/.test(userAgent) &&! /chrome/.test(userAgent);
		   const isIE = /msie |trident/.test(userAgent);
		   if (isSafari) {
		      console.log('当前使用的是苹果浏览器（Safari）');
		      return true;
		   } else if (isIE) {
		      console.log('当前使用的是 Internet Explorer 浏览器');
		      return false;
		   } else {
		      console.log('当前使用的不是苹果浏览器（Safari）和 Internet Explorer 浏览器');
		      return false;
		   }
		},
		
		set_height(){
			// this.swiper
			let swiper = document.getElementById(`swiper${this.fileList.post_id}`)
			
			if (swiper) {
				// 获取 swiper 容器的高度
				const swiperHeight = swiper.offsetHeight;
				// 获取所有的 slide_item 元素
				const swiperSlides = swiper.querySelectorAll('.slide_item');
				// 遍历所有的 slide_item 元素并设置高度
				swiperSlides.forEach((slide) => {
					slide.style.height = `${swiperHeight}px`;
				});
			}
		},
		
		async set_bg_color(type) {
			 // 使用 every 方法判断所有元素是否都具有 background 属性且有值
			 const allHaveBackground = this.fileList.pics.every(item => {
			     return item.hasOwnProperty('background') && item.background!== null && item.background!== undefined && item.background!== '';
			 });
			 
			 if (allHaveBackground) { return } //防止本函数里面的方法被多次调用
			 // 如果不是所有元素都满足条件，就继续往下执行
		    if (!this.fileList.pics) {
		        this.complete = true;
		        return;
		    }
			 let that = this
		    // 创建一个数组来存储每个图片加载的 Promise
		    const promises = this.fileList.pics.map((image, index) => {
		        return new Promise((resolve, reject) => {
		            const img = new Image();
		            img.crossOrigin = 'anonymous';
		            img.src = image.url;
		            img.onload = () => {
		                try {
		                    const canvas = document.createElement('canvas');
		                    const ctx = canvas.getContext('2d');
		                    canvas.width = img.width;
		                    canvas.height = img.height;
		                    ctx.drawImage(img, 0, 0);
		                    const imageData = ctx.getImageData(0, 0, img.width, img.height);
		                    const data = imageData.data;
		                    let topColor = `rgba(${data[0]}, ${data[1]}, ${data[2]}, 0.5)`;
		                    let bottomColor = `rgba(${data[(img.height - 1) * img.width * 4]}, ${data[(img.height - 1) * img.width * 4 + 1]}, ${data[(img.height - 1) * img.width * 4 + 2]}, 0.5)`;
		                    // 这里简单取左上角颜色作为背景蒙层颜色，你可以根据需求调整
		                    image.bgColor = topColor;
		                    image.bottomColor = bottomColor;
		                    image.background = `background: linear-gradient(to bottom, ${topColor}, ${bottomColor});`;
								  // if(image.video){
										// that.get_live_url(image).then(url => {
										//    image.video_new = url;
										//    console.log(image.video_new); // 这里才能输出正确的 `blob URL`
										// });
								  // }
		                    resolve(image);
		                } catch (error) {
		                    console.error(error);
		                    reject(error);
		                }
		            };
		            img.onerror = () => {
		                const error = new Error('图片加载失败');
		                console.error(error);
		                reject(error);
		            };
		        });
		    });
		    try {
		        // 等待所有图片加载完成
		        this.fileList.pics = await Promise.all(promises);
		        this.complete = true;
				  if(this.fileList.pics && this.fileList.pics.length > 1){
						this.set_height()
				  }
		        console.log(this.fileList.pics);
		    } catch (error) {
		        console.error('图片颜色提取出错:', error);
		    }
		},
		
		async get_live_url(image) {
		   const response = await fetch(image.video);
		   const blob = await response.blob();
			console.log(blob)
		   let video_new = URL.createObjectURL(blob);
			return video_new ? video_new : ''
		},
		
		handleClickSlide(clickedIndex){
			this.$nextTick(() => {
				var swiper = this.swiper;
				this.realIndex = swiper.activeIndex = clickedIndex
			});
		},
		
		change() {
			this.realIndex = this.swiper.realIndex
			this.$set(this.fileList, 'currentSlideIndex', this.realIndex+1); //更新序号
			if (this.swiper.realIndex !== this.indexOfPlayingVideo) {
			// this.pauseVideoCb()
			}
		},
		
		// 播放
		handlePlay(pauseVideoCb, slideIndex) {
			this.pauseVideoCb = pauseVideoCb
			this.indexOfPlayingVideo = slideIndex
		},
		
		//播放Live视频
		LivePlay(img_item) {
			if(img_item.LivePlayState){ return }
			this.swiper.autoplay.stop();
			this.$set(img_item, 'LivePlayState', true);
		   const videoElement = this.liveVideo;
			console.log(videoElement)
		   if (videoElement) {
				this.$set(img_item, 'LivePlayState', false);
				this.$set(videoElement, 'muted', true); // 静音
				this.$set(videoElement, 'controls', true); // 隐藏控件
		      videoElement.play();  // 播放视频
				
		      // videoElement.muted = true;  // 静音
		      // videoElement.controls = false;  // 隐藏控件
		      // videoElement.play();  // 播放视频
		   }
		},
		
		//Live视频播放完显示回图片
		stopLivePlay(img_item) {
			this.$set(img_item, 'LivePlayState', false);
			this.swiper.autoplay.start();
		   const videoElement = this.liveVideo;
		   if (videoElement) {
				this.$set(img_item, 'LivePlayState', false);
				this.$set(videoElement, 'currentTime', 0);
		      videoElement.pause();  // 播放视频
			
				// this.$set(img_item, 'LivePlayState', false);
				// this.$nextTick(() => {
				//    const videoElement = this.liveVideo;
				//    if (videoElement) {
				// 		videoElement.pause();  // 停止播放
				//       videoElement.currentTime = 0;  // 重置到视频开头
				//    }
				// });
		   }
		},
	  
		//鼠标移入暂停轮播
		stopAutoplay() {
		   // console.log('Stopping autoplay for:', this.swiper);
			if (this.swiper) {
				// console.log('Stopping autoplay for:', this.swiper);
				this.swiper.autoplay.stop();
			} else {
				console.warn('No swiper available to stop.');
			}
		},
		
		//鼠标移出开始轮播
		startAutoplay() {
		   // console.log('Stopping autoplay for:', this.swiper);
			if (this.swiper) {
				// console.log('Starting autoplay for:', this.swiper);
				this.swiper.autoplay.start();
			} else {
				console.warn('No swiperInstance available to start.');
			}
		},

	},
};
</script>

<style lang="less" scoped>
	 @import '~swiper/css/swiper.css';
	.picture_and_video_box {
	  margin-top: 15px;
	  // z-index: 0;
	  cursor: pointer;
	}

	.media-carousel {
	  width: 100%;
	  margin: 0 auto;
	}

	.media-image {
	  width: 100%;
	  height: auto;
	  object-fit: cover;
	  border-radius: 5px;
	}

	.Live-video{
	  width: 100%;
	  height: 100%;
	  border-radius: 5px;
	}
	.media-video {
	  width: 100%;
	  height: auto;
	  border-radius: 5px;
	}
	::v-deep .swiper-wrapper {
	   position: relative;
	   width: 100%;
	   height: 100%;
	   z-index: 1;
	   display: flex;
	   transition-property: transform;
	   box-sizing: content-box;
	   align-items: center;
	}
	
	::v-deep .swiper-container {
		width: 100%;
		height: 100%;
	   display: flex;
	}
	::v-deep .image-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		position: relative;
	}

	.swiper {
	  width: 100%;
	  height: auto;
	}
	.picture_and_video_box {
		.slide_item{
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100%;
			width: 100%;
		}
		::v-deep .swiper-slide {
		  display: flex;
		  justify-content: center;
		  align-items: center;
		  height: 100%;
		  border-radius: 5px;
		  overflow: hidden;
		  img{
			border-radius: 0px;
			width: 100%;
		  }
		}
	}
	

	::v-deep .swiper-pagination-bullet {
		width: 18px;
		height: 6px;
		display: inline-block;
		border-radius: 4px;
		background: #000;
		border: 1px #fff solid;
		opacity: 0.5;
		margin: 0px 4px;
	}
	.swiper-pagination {
	  position: absolute;
	  bottom: 10px;  /* Adjust to position the pagination at the bottom */
	  left: 50%;
	  width: 100%;
	  transform: translateX(-50%);
	  z-index: 10;
	}
	/deep/ .swiper-pagination-bullet-active {
	   opacity: 1;
		background: #06f;
		// background: #2094FA;
	}
	.media-carousel .swiper-slide{
		max-height: 100%;
	}
	.swiperBox{
		position: relative;
	}
	.quantityBox{
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 999;
		padding: 5px 10px;
		line-height: 1;
		background-color: rgba(0, 0, 0, 0.5);
		border: 1px #f5f5f5 solid;
		color: #ffffff;
		font-size: 12px;
		border-radius: 4px;
		display: flex;
	}
	.slideLiveBox{
		position: relative;
		video::-webkit-media-controls {
		    display: none!important;
		}
		video::-webkit-media-controls-enclosure {
		    display: none!important;
		}
		video::-webkit-media-controls-panel {
		    display: none!important;
		}
		
		video::-moz-media-controls {
		    display: none!important;
		}
		video::-moz-media-controls-enclosure {
		    display: none!important;
		}
		video::-moz-media-controls-panel {
		    display: none!important;
		}
		
		video::-ms-media-controls {
		    display: none!important;
		}
		video::-ms-media-controls-enclosure {
		    display: none!important;
		}
		video::-ms-media-controls-panel {
		    display: none!important;
		}
		
		video::media-controls {
		    display: none!important;
		}
		video::media-controls-enclosure {
		    display: none!important;
		}
		video::media-controls-panel {
		    display: none!important;
		}
	}
	.LiveBtn{
		position: absolute;
		top: 10px;
		left: 10px;
		z-index: 999;
		padding: 5px 10px;
		line-height: 1;
		background-color: rgba(0, 0, 0, 0.5);
		border: 1px #f5f5f5 solid;
		color: #ffffff;
		font-size: 14px;
		border-radius: 4px;
	}
	.LiveBtn.noBtn{
		background-color: #666666;
		color: #999999;
		border: 1px #666666 solid;
	}
	.pointer{
		cursor: pointer;
	}
	.no-drop{
		cursor: no-drop;
	}
	.pictures_or_videos{
		.picture_and_video_box{
		   margin-top: 0px !important;
		}
	}
	.StickyListBox .picture_and_video_box .slide_item{
		border-radius: 5px;
	}
	.picture_and_video_box .slide_item .media-video{
		border: 1px solid #f5f5f5;
		background: linear-gradient(to bottom, #2b2d3c, #333333);
	}
	.picture_and_video_box .swiper-slide img{
		width: 100%;
		object-fit: cover;
	}
	.picture_and_video_box .slide_item .media-video{
		width: 100%;
		background: linear-gradient(to bottom, #2b2d3c, #333333);
	}
	
	@media screen and (min-width: 1280px) {
		.picture_and_video_box .swiper-slide img{
			max-height: 70vh;
		}
		.picture_and_video_box .slide_item .media-video{
			max-height: 70vh;
			background: linear-gradient(to bottom, #2b2d3c, #333333);
		}
	}
	@media screen and (max-width: 1024px) and (min-width: 768px) {
	   .picture_and_video_box .swiper-slide img{
	   	max-height: 70vh;
	   }
	   .picture_and_video_box .slide_item .media-video{
	   	max-height: 70vh;
	   	background: linear-gradient(to bottom, #2b2d3c, #333333);
	   }
	}
	@media screen and (max-width: 768px) and (min-width: 600px) {
	   .picture_and_video_box .swiper-slide img{
	   	max-height: 70vh;
	   }
	   .picture_and_video_box .slide_item .media-video{
	   	max-height: 70vh;
	   	background: linear-gradient(to bottom, #2b2d3c, #333333);
	   }
	}
	@media screen and (max-width: 600px) and (min-width: 500px) {
	   .picture_and_video_box .swiper-slide img{
	   	max-height: 70vh;
	   }
	   .picture_and_video_box .slide_item .media-video{
	   	max-height: 70vh;
	   	background: linear-gradient(to bottom, #2b2d3c, #333333);
	   }
	}
	@media screen and (min-width: 500px) {
		.StickyListBox .picture_and_video_box .swiper-slide img{
			width: 100%;
			height: 150px;
			object-fit: cover;
		}
		.StickyListBox .picture_and_video_box .slide_item .media-video{
			width: 100%;
			height: 150px;
		}
	}
	@media screen and (max-width: 500px) {
		.picture_and_video_box .swiper-slide img{
			max-height: 70vh;
		}
		.picture_and_video_box .slide_item .media-video{
			max-height: 70vh;
			background: linear-gradient(to bottom, #2b2d3c, #333333);
		}
		.StickyListBox .picture_and_video_box .swiper-slide img{
			width: 100%;
			height: 120px;
			object-fit: cover;
		}
		.StickyListBox .picture_and_video_box .slide_item .media-video{
			width: 100%;
			height: 120px;
		}
	}
</style>
